import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger",
  "data-testid": "error-msg"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = { class: "form-group row text-right" }
const _hoisted_5 = { class: "col-sm-9" }
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "col-sm-3 label-key"
}
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 1,
  for: "uploadpasswordfield",
  class: "col-sm-3 control-label label-key"
}
const _hoisted_10 = { class: "col-sm-9" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "form-group row text-right" }
const _hoisted_16 = { class: "col-sm-9" }
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = { class: "input-group-addon" }
const _hoisted_19 = ["disabled", "placeholder"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "col-sm-9" }
const _hoisted_22 = ["disabled", "placeholder"]
const _hoisted_23 = {
  key: 0,
  class: "help-block"
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "form-group row" }
const _hoisted_26 = { class: "col-sm-offset-3 col-sm-9" }
const _hoisted_27 = { class: "checkbox" }
const _hoisted_28 = { class: "form-group row" }
const _hoisted_29 = { class: "col-sm-12" }
const _hoisted_30 = { class: "help-block" }
const _hoisted_31 = { class: "text-info" }
const _hoisted_32 = { class: "text-right" }
const _hoisted_33 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (!!_ctx.uploadSetting.errorMsg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", null, _toDisplayString(_ctx.uploadSetting.errorMsg), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[13] || (_cache[13] = _createElementVNode("label", {
            for: "storageuploadtype",
            class: "col-sm-3 control-label label-key"
          }, " Key Type: ", -1)),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.uploadSetting.keyType) = $event)),
              name: "uploadKeyType",
              class: "form-control"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keyTypes, (option) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: option.value,
                  value: option.value
                }, _toDisplayString(option.text), 9, _hoisted_6))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.uploadSetting.keyType]
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "help-block text-left" }, " Private Keys and Passwords are not available to download once they are stored. Public keys can be downloaded. ", -1))
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["form-group row text-right", [_ctx.validInput() === true ? 'has-success' : 'has-warning']])
        }, [
          (_ctx.uploadSetting.keyType !== 'password')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.uploadSetting.inputType) = $event)),
                  class: "form-control",
                  name: "inputType"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputTypes, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.value,
                      value: option.value
                    }, _toDisplayString(option.text), 9, _hoisted_8))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.uploadSetting.inputType]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.uploadSetting.keyType === 'password')
            ? (_openBlock(), _createElementBlock("label", _hoisted_9, " Enter text "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            (
                _ctx.uploadSetting.inputType === 'text' &&
                _ctx.uploadSetting.keyType !== 'password'
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("textarea", {
                    id: "storageuploadtext",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.uploadSetting.textArea) = $event)),
                    class: "form-control",
                    rows: "5",
                    name: "uploadText"
                  }, null, 512), [
                    [_vModelText, _ctx.uploadSetting.textArea]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.uploadSetting.inputType === 'file')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("input", {
                    id: "file",
                    ref: "file",
                    type: "file",
                    onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args)))
                  }, null, 544)
                ]))
              : _createCommentVNode("", true),
            (
                _ctx.uploadSetting.inputType === 'text' &&
                _ctx.uploadSetting.keyType === 'password'
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    id: "uploadpasswordfield",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.uploadSetting.password) = $event)),
                    name: "uploadPassword",
                    type: "password",
                    placeholder: _ctx.$t('storage.enter.password'),
                    autocomplete: "new-password",
                    class: "form-control"
                  }, null, 8, _hoisted_14), [
                    [_vModelText, _ctx.uploadSetting.password]
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2),
        _createElementVNode("div", _hoisted_15, [
          _cache[14] || (_cache[14] = _createElementVNode("label", {
            for: "uploadResourcePath2",
            class: "col-sm-3 control-label label-key"
          }, " Storage path: ", -1)),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", null, _toDisplayString(_ctx.rootPath), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                id: "uploadResourcePath2",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.uploadSetting.inputPath) = $event)),
                disabled: _ctx.uploadSetting.modifyMode === true,
                name: "relativePath",
                class: "form-control",
                "data-testid": "key-path-input",
                placeholder: _ctx.$t('storage.enter.directory.name')
              }, null, 8, _hoisted_19), [
                [_vModelText, _ctx.uploadSetting.inputPath]
              ]),
              _withDirectives(_createElementVNode("input", {
                id: "uploadResourcePath3",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.uploadSetting.inputPath) = $event)),
                disabled: _ctx.uploadSetting.modifyMode === false,
                type: "hidden",
                name: "relativePath"
              }, null, 8, _hoisted_20), [
                [_vModelText, _ctx.uploadSetting.inputPath]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass([
            'form-group',
            'row',
            _ctx.uploadSetting.fileName == null && _ctx.uploadSetting.inputType !== 'file'
              ? 'has-warning'
              : '',
            _ctx.uploadSetting.fileName != null && _ctx.uploadSetting.inputType !== 'file'
              ? 'has-success'
              : '',
          ])
        }, [
          _cache[15] || (_cache[15] = _createElementVNode("label", {
            for: "uploadResourceName2",
            class: "col-sm-3 control-label label-key text-right"
          }, " Name: ", -1)),
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("input", {
              id: "uploadResourceName2",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.uploadSetting.fileName) = $event)),
              disabled: _ctx.uploadSetting.modifyMode === true,
              name: "fileName",
              class: "form-control",
              "data-testid": "key-name-input",
              placeholder: _ctx.$t('storage.specify.name')
            }, null, 8, _hoisted_22), [
              [_vModelText, _ctx.uploadSetting.fileName]
            ]),
            (_ctx.uploadSetting.inputType === 'file')
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, " If not set, the name of the uploaded file is used. "))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("input", {
              id: "uploadResourceName3",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.uploadSetting.fileName) = $event)),
              type: "hidden",
              disabled: _ctx.uploadSetting.modifyMode === false,
              name: "fileName"
            }, null, 8, _hoisted_24), [
              [_vModelText, _ctx.uploadSetting.fileName]
            ])
          ])
        ], 2),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.uploadSetting.dontOverwrite) = $event)),
                type: "checkbox",
                value: "true",
                name: "dontOverwrite"
              }, null, 512), [
                [_vModelCheckbox, _ctx.uploadSetting.dontOverwrite]
              ]),
              _cache[16] || (_cache[16] = _createElementVNode("label", null, " Do not overwrite a file with the same name. ", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _cache[17] || (_cache[17] = _createElementVNode("p", null, "You can reference this stored Key using the storage path:", -1)),
              _createElementVNode("p", null, [
                _createElementVNode("strong", _hoisted_31, _toDisplayString(_ctx.uploadFullPath), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-default mr-3",
          "data-testid": "cancel-btn",
          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleCancel && _ctx.handleCancel(...args)))
        }, " Cancel "),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-cta",
          "data-testid": "save-btn",
          disabled: _ctx.validInput() === false,
          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleUploadKey && _ctx.handleUploadKey(...args)))
        }, " Save ", 8, _hoisted_33)
      ])
    ])
  ]))
}